module.exports = __webpack_public_path__ + "images/a-klevtsov-8f78b0.jpg";